import { useState } from "react";

const ShippingForm = ({ masterModalData, SetMasterModalData ,closeModal}) => {
  const [shipmentCharge, setShipmentCharge] = useState(
    masterModalData.shipping_type || ""
  );
  const [amount, setAmount] = useState(masterModalData.shipping_amt || "");

  const handleSubmit = () => {
    SetMasterModalData({
      shipping_type: shipmentCharge,
      shipping_amt: parseFloat(amount) || 0,
    });
    closeModal();
  };

  return (
    <div className="bg-white px-6 py-3 rounded-lg">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Shipping Configuration
        </h2>
        <p className="text-gray-600 text-sm">
          Configure shipping charges and amounts for your orders
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <label
            htmlFor="shipmentCharge"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Shipment Charge Name
          </label>
          <input
            type="text"
            id="shipmentCharge"
            value={shipmentCharge}
            onChange={(e) => setShipmentCharge(e.target.value)}
            placeholder="Enter shipment charge name (e.g., Standard Shipping)"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label
            htmlFor="amount"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Amount
          </label>
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            step="0.01"
            min="0"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="flex gap-3 pt-4">
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Save Shipping
          </button>
          <button
            onClick={() => {
              setShipmentCharge("");
              setAmount("");
            }}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};
export default ShippingForm;
